import i18next from 'i18next';
import { CountryEnum } from '../../../enuns/country.enum';

const languageMap = {
    [CountryEnum.Argentina]: 'AS',
    [CountryEnum.Equador]: 'AS',
    [CountryEnum.Peru]: 'AS',
    [CountryEnum.Colombia]: 'AS',
    [CountryEnum.Chile]: 'AS',
    [CountryEnum.Uruguai]: 'AS',
    [CountryEnum.Brasil]: 'BR',
    [CountryEnum.RepublicaDominicana]: 'AS',
    [CountryEnum.Guatemala]: 'AS',
    [CountryEnum.ElSalvador]: 'AS',
    [CountryEnum.Panama]: 'AS',
};

export const i18nMixin = {
    getLanguageMap: (country) => {
        return languageMap[country];
    },
    methods: {
        i18n(text, properties = {}) {
            let output = i18next.t(text, properties);

            if (output === text) {
                console.log(`No translation available for ${text}`);
                // console.trace();
                if (properties.empty) {
                    output = '';
                }
            }

            return output;
        },

        mountLanguage(lng) {
            const lang = (lng).split('-');
            return `${lang[0]}-${languageMap[window.NeoGIG.country]}`;
        },

        getCurrentLanguage() {
            return this.mountLanguage(localStorage.getItem('language') || i18next.language);
        },

        changeLanguage(lng) {
            const l = this.mountLanguage(lng);
            localStorage.setItem('language', l);
            i18next.changeLanguage(l);
            location.reload();
        },
        
        setLanguage(locale) {
            this.changeLanguage(locale);
        }
    }
};



// WEBPACK FOOTER //
// ./src/modules/shared/mixins/i18n.mixin.js